import AddSvg from '@/common/assets/icons/add.svg?react';
import Button from '@/common/components/base/button/Button';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import MainLayout from '@/common/components/layouts/MainLayout';
import AccessoryList from '@/modules/adjusterReportModules/IncidentParticipants/components/expert/AccessoryList';
import { useNavigate } from 'react-router-dom';
import { Box } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';
import { INITIAL_VISIT_ACCESSORY_FORM } from '../../initialVisitLink';

export default ({ isEditable = true }: { isEditable?: boolean }) => {
  return (
    <MainLayout title="بازدید اولیه / کارشناسی" header="titleHeader">
      <InitialVisitAccessory isEditable={isEditable} />
    </MainLayout>
  );
};

const InitialVisitAccessory = ({
  isEditable = true,
}: {
  isEditable?: boolean;
}) => {
  const navigate = useNavigate();

  return (
    <Box pt={24}>
      <TitleDescription>لوازم اضافی</TitleDescription>
      {isEditable && (
        <Button
          fullWidth
          mt={24}
          variant="outlined"
          color="success"
          onClick={() => navigate(INITIAL_VISIT_ACCESSORY_FORM)}
        >
          <Box mx={12}>
            <AddSvg stroke={token('colors.green-2')} width={20} height={20} />
          </Box>
          افزودن قطعه
        </Button>
      )}
      <AccessoryList isEditable={isEditable} />
    </Box>
  );
};
